import * as RadixSwitch from '@radix-ui/react-switch';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '../utils/className';

export type ToggleProps = ComponentPropsWithoutRef<typeof RadixSwitch.Root>;

/**
 * Toggle (Switch) Component
 *
 * An iOS-style toggle switch for binary on/off states
 * Based on the design from Figma (iOS Toggle component)
 */
export function Toggle({ className, ...props }: ToggleProps) {
  return (
    <RadixSwitch.Root
      className={cn(
        'relative h-5 w-9 shrink-0 rounded-full transition-colors',
        'bg-surface-disabled',
        'data-checked:bg-surface-focus',
        `focus-visible:ring-focus focus-visible:ring-1
        focus-visible:outline-none`,
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <RadixSwitch.Thumb
        className={cn(
          `block size-3.5 cursor-pointer rounded-full bg-white shadow-md
          transition-transform duration-75`,
          'translate-x-0.75 data-checked:translate-x-4.25'
        )}
      />
    </RadixSwitch.Root>
  );
}
